import React from 'react';

import {
  Step
} from 'src/types';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import ConnectToSlackButton from 'src/components/ConnectToSlackButton';
import { FieldConfig } from 'src/components/formik/FormikConfigForm';
import useGetRequest from 'src/hooks/useGetRequest';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikSlateRichTextArea from '../../../../components/formik/FormikSlateRichTextArea';

interface Props {
  step: Step,
}

interface Conversation {
  id: string,
  name: string
}

const SlackMessageForm = ({ step }: Props) => {
  const {
    result: conversations,
    httpRequest: listConversations
  }: {
    result: Conversation[],
    httpRequest: () => void
  } = useGetRequest({
    // @ts-ignore - step will have an action
    url: '/automatic/integrations/slack/list-conversations/',
    shouldFetchOnInitialRender: false,
    initialResult: []
  });

  const { result: hasSlackConnection, isLoading } = useGetRequest({
    // @ts-ignore - step will have an action
    url: '/automatic/integrations/slack/',
    onSuccess: () => listConversations(),
  });

  if (isLoading) return null;
  // todo - make add to slack a separate component - show connected with checkbox w/optional reconnect if already connected

  const fieldsConfig: FieldConfig[] = [
    {
      name: 'conversationId',
      component: () => (
        <FormikSelect
          fullWidth
          label="Channel"
          name="conversationId"
          options={conversations.map(({ id, name }) => ({
            label: name,
            value: id,
          }))}
        />
      ),
    },
    {
      name: 'message',
      component: () => (
        <FormikSlateRichTextArea
          id="message"
          label="Message"
          name="message"
          showToolbar
          workflowId={step.workflowId}
        />
      ),
    },
  ];

  return (
    <>
      {hasSlackConnection ? (
        <CRUDConfigForm
          url={`/automatic/workflows/${step.workflowId}/slack-messages/`}
          objectId={step.action && step.action.slackMessage && step.action.slackMessage.id}
          fieldsConfig={fieldsConfig}
          autoSave
        />
      ) : <ConnectToSlackButton />}
    </>
  );
};

export default SlackMessageForm;
